import React, { useState } from 'react';

import previewActions from '../../../redux/actions/previewActions';

import AnalyticsSender from '../../../helpers/analyticsSender';

const PreviewsCategoryMobile = (props: { categories: any, analytics: any }) => {
	const { previewCategory, previewSetCategory, previewSetSelected } =
    previewActions();

	const analyticsSender = new AnalyticsSender();

	const [isSelectActive, setSelectActive] = useState(false);

	const selectedCategory = props.categories
		.filter((category) => category.key === previewCategory)
		.pop();

	return (
		<div className="previews__category previews__category_mobile">
			<div className="form__group">
				<label>
					<div className="select-list">
						<div
							className="select-item"
							onClick={(e) => {
								e.preventDefault();
								setSelectActive(!isSelectActive);
							}}
						>
							{getIconCategory(selectedCategory.key, false)}{' '}
							{selectedCategory.description}
							<i
								style={{ opacity: '1' }}
								className={'arrow ' + (isSelectActive ? 'arrow_active' : '')}
							/>
						</div>
          
						<div
							className="options"
							style={{ display: isSelectActive ? 'flex' : 'none' }}
						>
							{generateCategoryOptions(
								props.categories,
								isSelectActive,
								setSelectActive,
								previewSetSelected,
								previewSetCategory,
								analyticsSender.sendClickCategoryPreview,
								previewCategory
							)}
						</div>
					</div>
				</label>
			</div>
		</div>
	);
};

const generateCategoryOptions = (
	categories,
	isSelectActive,
	setSelectActive,
	previewSetSelected,
	previewSetCategory,
	sendClickCategoryPreview,
	previewCategory
) => {

	const selectCategory = (key) => {
		setSelectActive(!isSelectActive);
		previewSetSelected([]);
		previewSetCategory(key);
		sendClickCategoryPreview(key);
	};

	return categories.map((category, key) => {
		return (
			<button key={key} className={`option option__preview ${category.key == previewCategory && 'option__preview_active'}`} type="button" onClick={() => selectCategory(category.key)}>
				{getIconCategory(category.key, category.key == previewCategory )}
				{category.description}
			</button>
		);
	});
};

const getIconCategory = (key, isBlue) => {
	const icon = `icon__${key} ${isBlue ? `icon__${key}_blue` : ''}`;
	return <i className={icon} />;
};

export default PreviewsCategoryMobile;
